import { Box, CircularProgress, CircularProgressProps, SxProps, Typography } from '@mui/material';

interface CircularProgressWithLabelProps extends CircularProgressProps {
  containerSx?: SxProps;
}
export default function CircularProgressWithLabel({
  value,
  containerSx,
  ...other
}: CircularProgressWithLabelProps) {
  return (
    <Box sx={[{ position: 'relative', display: 'inline-flex' }, containerSx] as SxProps}>
      <CircularProgress variant="determinate" value={value} {...other} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" color="primary.contrastText">{`${Math.round(value!)}%`}</Typography>
      </Box>
    </Box>
  );
}
